import React, { useState } from 'react';
import { Sun, Moon, Check } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../utils/cn';

const ThemeToggle = ({ variant = 'button', className = '' }) => {
  const { theme, toggleTheme, setLightTheme, setDarkTheme, isDark } = useTheme();
  const [showMenu, setShowMenu] = useState(false);

  if (variant === 'simple') {
    // Simple toggle button
    return (
      <button
        onClick={toggleTheme}
        className={cn(
          'p-2 rounded-lg transition-colors',
          'hover:bg-gray-100 dark:hover:bg-gray-800',
          'text-gray-600 dark:text-gray-300',
          className
        )}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode (currently ${theme})`}
      >
        {isDark ? (
          <Sun className="h-5 w-5" />
        ) : (
          <Moon className="h-5 w-5" />
        )}
      </button>
    );
  }

  // Full dropdown menu version
  return (
    <div className={cn('relative', className)}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        className={cn(
          'flex items-center gap-2 p-2 rounded-lg transition-colors',
          'hover:bg-gray-100 dark:hover:bg-gray-800',
          'text-gray-600 dark:text-gray-300',
          'border border-gray-200 dark:border-gray-700'
        )}
        title="Theme options"
      >
        {theme === 'light' && <Sun className="h-4 w-4" />}
        {theme === 'dark' && <Moon className="h-4 w-4" />}
        <span className="text-sm font-medium capitalize">{theme}</span>
      </button>

      {showMenu && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowMenu(false)}
          />
          
          {/* Menu */}
          <div className="absolute right-0 top-full mt-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-20 min-w-[140px]">
            <div className="p-1">
              <button
                onClick={() => {
                  setLightTheme();
                  setShowMenu(false);
                }}
                className={cn(
                  'w-full flex items-center gap-3 px-3 py-2 text-sm rounded-md transition-colors',
                  'hover:bg-gray-100 dark:hover:bg-gray-700',
                  theme === 'light' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'
                )}
              >
                <Sun className="h-4 w-4" />
                <span>Light</span>
                {theme === 'light' && <Check className="h-4 w-4 ml-auto" />}
              </button>
              
              <button
                onClick={() => {
                  setDarkTheme();
                  setShowMenu(false);
                }}
                className={cn(
                  'w-full flex items-center gap-3 px-3 py-2 text-sm rounded-md transition-colors',
                  'hover:bg-gray-100 dark:hover:bg-gray-700',
                  theme === 'dark' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'
                )}
              >
                <Moon className="h-4 w-4" />
                <span>Dark</span>
                {theme === 'dark' && <Check className="h-4 w-4 ml-auto" />}
              </button>
              
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ThemeToggle;
